import { UiStatus } from "../../_shared/Emails/Emails.types";

export const isRemediable = (uiStatus: string) => {
  return ![UiStatus.AUTO_REMEDIATED, UiStatus.REMEDIATED].includes(
    uiStatus as UiStatus,
  );
};

export const isMarkableAsSafe = (uiStatus: string) =>
  ![UiStatus.MARKED_AS_SAFE, UiStatus.QUARANTINED].includes(
    uiStatus as UiStatus,
  );
